@import '../../theme/colors';
@import '../../theme/mixins';

.helpContainer {
  display: flex;
  flex-direction: column;
  position: relative;
  height: max-content;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 13px 0 11px;

    h1 {
      margin-right: 32px;
    }
  }
}

.circularProgress {
  position: absolute;
  top: 35vh;
  left: 50%;
}

.helpContent {
  display: flex;
  min-height: 48px;

  .contentHeader {
    height: 44px;
    display: flex;
    align-items: center;
    padding: 0 16px 0 30px;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 1px solid #8a8a8a;
    justify-content: space-between;

    .fullScreenText {
      color: #006da8;
      font-weight: normal;
      font-size: 14px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      cursor: pointer;

      span {
        margin-left: 2px;
      }
    }
  }

  .helpDocuments {
    width: 100%;
    border: 1px solid #dadada;
  }

  .documentsContainer {
    position: relative;
    max-height: calc(100% - 45px);
    height: calc(100% - 45px);
    padding: 0 0 20px 57px;
    min-width: min-content;
    overflow-y: auto;
    overflow-x: auto;

    .document {
      border-bottom: 1px solid $neutral-400;
      margin-bottom: 10px;
      padding: 25px 0;
      padding-right: 10px;
      position: relative;

      .documentTools {
        position: absolute;
        right: 16px;
        top: 10px;
        z-index: 99;

        .statusIndicators {
          display: flex;
          .statusChip {
            border: 1px solid $statusBorder;
            border-radius: 4px;
            font-size: 11px;
            color: $navy;
            padding: 2px 4px;
            margin-left: 4px;
          }
        }

        .documentActions {
          display: flex;
          justify-content: flex-end;
          margin-top: 2px;

          svg {
            height: 20px;
            width: 20px;
          }
        }
      }
    }

    .preview {
      padding: 10px;
      background-color: #f6f6f6;

      div {
        max-height: 120px;
      }
    }

    a[href].previewContainer {
      text-decoration: initial !important;
      color: initial !important;
    }

    .previewContainer {
      max-height: 120px;
      overflow: hidden;
      margin-bottom: 35px;
      display: block;
      text-decoration: none;
      color: inherit;

      span {
        margin: 4px;
        display: block;
        font-size: 14px;
      }
    }
  }
}

.tableOfContents {
  min-width: 240px;
  max-height: 100%;
  background-color: #efefef;
  font-family: var(--font-family__heading);
  color: #4f4f4f;
  border-bottom: 1px solid #d5d5d5;

  .tableHeader {
    height: 45px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    border-bottom: 1px solid #8a8a8a;
  }

  .folders {
    max-height: calc(100% - 46px);
    height: calc(100% - 46px);
    overflow: hidden;
  }

  .documentSection {
    position: relative;
    min-height: 43px;
    font-size: 14px;
    display: flex;
    align-items: center;
    .navLink {
      margin-left: 10px;
    }
  }

  .isTopLevelDoc {
    font-size: 16px;
    border-top: 2px solid #d5d5d5;
    &:not(.parent) {
      padding-left: 30px;
    }
  }

  .navLink {
    @include label2;
    text-decoration: none;
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 12px;
    margin-bottom: 12px;
    cursor: pointer;
  }

  .isTopLevelDoc .navLink {
    font-size: 16px;
  }

  .active {
    background-color: white;
    box-sizing: border-box;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 100%;
      background-color: $oceanBlue;
    }
  }

  .activeLink {
    color: #006dd5;
    font-weight: bold;
  }

  .collapsibleSection {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .collapseIcon {
      cursor: pointer;
      transform: rotate(0);
      margin: 0 2px 0 3px;
    }
    .parent {
      position: relative;
      .collapsibleParentContent {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        border-bottom: 2px solid #d5d5d5;
      }
    }

    .children {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }

  .collapsibleSectionClosed {
    border-bottom: none;
    .collapseIcon {
      transform: rotate(-90deg);
    }
    &:last-child .parent,
    .isTopLevelDoc {
      .collapsibleParentContent {
        border-bottom: none;
      }
    }

    .children {
      height: 0 !important;
      min-height: 0 !important;
    }
  }
}

.scrolling {
  min-width: min-content;

  & > div:first-child {
    overflow-x: auto !important;
    padding: 10px 0;
    max-width: unset;
  }
}

.scrollTableOfContents {
  min-width: min-content;

  & > div:first-child {
    overflow-x: hidden !important;
    min-width: min-content;
    margin-bottom: 0px !important;
  }
  .helpListDragIcon {
    min-width: 24px;
  }
}

.treeList {
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: $midLightGray;
  width: 240px;
  padding-bottom: 30px;
  a {
    @include label2;
    text-decoration: none;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
  }
  .treeListItem {
    position: relative;
    background-color: $neutral-200;

    .treeListItemContent {
      display: flex;
      align-items: center;
      background-color: $neutral-200;
      padding-right: 40px;
      padding-left: 8px;

      .treeListCollapseIcon {
        margin-left: -5px;
      }
      .treeListItemLink {
        padding: 12px 0;
        height: auto;
        width: auto;
        max-width: 100%;
        word-break: break-word;
      }
    }
    &.topLevel {
      .treeListItemContent {
        a {
          font-size: 16px;
        }
      }
    }
    &.topLevel:not(:first-child) {
      border-top: $midLightGray 2px solid;
    }
    &.treeListItemActive {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background-color: $oceanBlue;
      }
      background-color: white;
      .treeListItemContent {
        background-color: white;
        .treeListItemLink {
          color: $oceanBlue;
          font-weight: 700;
        }
      }
    }
    .treeListItemHandle {
      padding: 8px;
      position: absolute;
      right: 0px;
    }
  }
}

.helpDroppable {
  min-height: 20px;
  &.isDraggingOver {
    background-color: white;
  }
}

.globalTree {
  height: 65vh;

  button {
    display: block;
    margin-left: auto;
  }

  .tree {
    list-style: none;
    padding-inline-start: 0px;
    border: 1px solid $neutral-300;
    border-radius: 4px;
    overflow: auto;
    height: 60vh;
    position: relative;

    & > span:last-child {
      position: absolute;
      bottom: 0;
      left: 22px;
    }

    .scroll {
      height: 94% !important;

      & > div:first-child {
        padding: 16px 22px;
      }
      li {
        margin-bottom: 21px;

        display: flex;
        & > span:last-child {
          margin-left: 7px;
        }
      }
    }
  }
}

.document {
  border-bottom: 1px solid $neutral-400;
  margin-bottom: 10px;
  padding: 25px 0;
  position: relative;
  .documentTools {
    position: absolute;
    right: 16px;
    top: 10px;
    z-index: 99;

    .statusIndicators {
      display: flex;
      .statusChip {
        border: 1px solid $statusBorder;
        border-radius: 4px;
        font-size: 11px;
        color: $navy;
        padding: 2px 4px;
        margin-left: 4px;
      }
    }

    .documentActions {
      display: flex;
      justify-content: flex-end;
      margin-top: 2px;

      svg {
        height: 20px;
        width: 20px;
      }
    }
  }
}

.userForm {
  margin: 40px 0;
}

.modalActionFooter {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  button {
    width: 70px;
  }
}
